import { useContext } from "react";
import { useSelector } from "react-redux";

import { RightArrowIcon } from "../../../../client/assets/icons/common/RightArrowIcon";
import { BaseBenefitsList } from "../../../../components/BaseComponents/BaseBenefitsList";
import { BaseCafNumber } from "../../../../components/BaseComponents/BaseCafNumber";
import { BaseCallOut } from "../../../../components/BaseComponents/BaseCallOut";
import { BaseColorBarRatingSection } from "../../../../components/BaseComponents/BaseColorBarRatingSection";
import { BaseCompanyLogo } from "../../../../components/BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "../../../../components/BaseComponents/BaseCompanyName";
import { BaseFeaturedCompanyHeader } from "../../../../components/BaseComponents/BaseFeaturedCompanyHeader";
import BaseLinkWrapper from "../../../../components/BaseComponents/BaseLinkWrapper";
import BasePhoneLink from "../../../../components/BaseComponents/BasePhoneLink";
import BaseReviewLink from "../../../../components/BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../../../components/BaseComponents/BaseServiceFlag";
import { BaseVisitLink } from "../../../../components/BaseComponents/BaseVisitLink";
import { CompanyContext } from "../../../../components/CompanyList/CompanyContext";
import { getAwardText, getCompanyPhoneNumber } from "../../../../selectors";
import { RightIcon } from "../../../assets/icons/RightIcon";
import { getStyles } from "./styles";

export const TCRLegacyLayout = () => {
	const { company, isFeaturedCompany } = useContext(CompanyContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));
	const styles = getStyles({ awardText });
	const phoneNumber = useSelector((state) =>
		getCompanyPhoneNumber(state, { company }),
	);
	const companyName = company?.fields?.companyName;

	return (
		<div
			className={`tw:relative tw:mx-auto tw:max-w-[500px] tw:bg-white tw:md:mx-[initial] tw:md:max-w-none ${isFeaturedCompany ? "tw:mt-8 tw:rounded-sm tw:[border:1.5px_solid_#4299e1]" : "tw:mt-4.5 tw:rounded-[3px] tw:shadow-[0_1px_2px_rgba(0,0,0,0.07)] tw:[border:1px_solid_#d6dbdf]"}`}
		>
			<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />

			<div className="tw:relative tw:flex tw:flex-col tw:desktop:flex-row">
				<BaseServiceFlag classNames={styles.serviceFlag} />

				<div className="tw:pt-[20px] tw:pb-[10px] tw:xs2:pt-[20px] tw:xs2:pb-0 tw:md:p-[20px] tw:desktop:flex tw:desktop:w-[40%] tw:desktop:p-0">
					<div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:desktop:w-full">
						<BaseLinkWrapper className="tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-center">
							<BaseCompanyLogo classNames={styles.companyLogo} />

							<BaseCafNumber className={styles.cafNumber} />
						</BaseLinkWrapper>

						<BaseReviewLink
							classNames={styles.rightSecitonReviewLink}
							linkText="Read Full 2025 Review"
							suffixIcon={
								<RightIcon className="tw:text-[18px] tw:text-[#333742]" />
							}
						/>
					</div>

					<div className="tw:mt-[4px] tw:hidden tw:w-full tw:px-[10px] tw:py-[5px] tw:md:flex tw:desktop:mt-0 tw:desktop:w-fit tw:desktop:p-0">
						<BaseColorBarRatingSection classNames={styles.ratingSection} />
					</div>
				</div>

				<div className="tw:flex tw:flex-col tw:items-center tw:p-[10px] tw:xs2:p-[20px] tw:md:flex-row tw:md:justify-between tw:md:py-0 tw:desktop:w-[60%] tw:desktop:justify-between tw:desktop:p-[20px]">
					<BaseLinkWrapper className="tw:flex tw:w-full tw:flex-col tw:xs2:mx-auto tw:xs2:max-w-[380px] tw:md:mx-[initial] tw:desktop:max-w-[280px] tw:lg2:max-w-[380px]">
						<BaseCompanyName className="tw:font-montserrat tw:text-[1.375rem] tw:leading-[1.3] tw:font-semibold tw:text-[#333742]" />

						<BaseCallOut className={styles.callOut} />

						<BaseBenefitsList
							{...styles.benefitsList}
							isExpandable={true}
							mobileItemsToShow={2}
						/>
					</BaseLinkWrapper>

					<div className="tw:flex tw:w-full tw:flex-col tw:items-center tw:justify-center tw:xxs2:flex-row tw:md:w-auto tw:md:flex-col tw:desktop:mt-0 tw:desktop:w-fit tw:desktop:flex-col tw:desktop:items-center tw:desktop:justify-center tw:lg2:mr-0">
						<BasePhoneLink
							company={company}
							className="tw:relative tw:mb-[10px] tw:h-[52px] tw:w-auto tw:max-w-[300px] tw:rounded-[3px] tw:pt-[15px] tw:pr-[10px] tw:pb-[13px] tw:pl-[15px] tw:[border:1px_solid_#d6dbdf] tw:before:absolute tw:before:top-[15px] tw:before:left-[5px] tw:before:h-[24px] tw:before:w-[24px] tw:before:bg-[url(/public/react-images/common/phone.svg)] tw:before:bg-size-[30px_20px] tw:before:bg-no-repeat tw:xxs2:mr-[15px] tw:xxs2:mb-0 tw:md:mx-0 tw:md:mb-[25px] tw:md:h-auto tw:md:w-full tw:md:border-none tw:md:py-0 tw:md:pr-0 tw:md:pl-[40px] tw:md:before:top-[5px] tw:md:before:left-0 tw:md:before:h-[34px] tw:md:before:w-[34px] tw:md:before:bg-size-[initial]"
						>
							<span className="tw:hidden tw:font-avenirNextDemi tw:text-[1rem] tw:leading-[1.1] tw:font-medium tw:tracking-tighter tw:text-[#333742] tw:md:block">
								Free Credit Consultation
							</span>
							<span className="tw:relative tw:bottom-[-2px] tw:pl-[20px] tw:font-avenirNextDemi tw:text-[1.2rem] tw:leading-[1.1] tw:font-medium tw:tracking-[-1px] tw:text-[#1d8ce0] tw:md:pl-0 tw:md:text-[1.5rem]">
								{phoneNumber}
							</span>
						</BasePhoneLink>

						<BaseLinkWrapper className="tw:group tw:relative tw:mt-[15px] tw:inline-flex tw:w-[160px] tw:items-center tw:justify-center tw:rounded-[3px] tw:bg-[#6ac54e] tw:p-[10px] tw:text-white tw:shadow-[0_3px_8px_#2a5a1b54] tw:hover:bg-[#14a929] tw:xxs2:mt-0 tw:md:w-[210px] tw:md:px-[20px] tw:md:py-[13px]">
							<BaseVisitLink {...styles.visitLink} icon={<RightArrowIcon />}>
								{companyName && (
									<small className="tw:block tw:font-avenirNextDemi tw:text-[12px] tw:text-white/80">
										{companyName}
									</small>
								)}

								<span className="tw:block tw:font-montserrat tw:text-[1.3rem]">
									Visit Website
								</span>
							</BaseVisitLink>
						</BaseLinkWrapper>

						{phoneNumber == null && (
							<BaseReviewLink
								classNames={styles.reviewLink}
								linkText="Read Our Review"
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
